// UI Translations for the app
export const translations = {
  en: {
    // Sidebar
    chats: 'Chats',
    newChat: 'New Chat',
    documents: 'Documents',
    analytics: 'Analytics',
    profile: 'Profile',
    settings: 'Settings',
    language: 'Language',
    upgradePlan: 'Upgrade Plan',
    learnMore: 'Learn More',
    logout: 'Logout',
    selectLanguage: 'SELECT LANGUAGE',
    admin: 'Admin',

    // Chat
    messagePlaceholder: 'Ask Tuliza...',
    howCanIHelp: 'How can I help with your health and wellbeing today?',
    askAnything: 'Ask me anything about health, wellbeing, or community support',

    // Greeting
    quickTopics: 'Quick Topics:',
    nhsRegistration: 'NHS Registration',
    healthServices: 'Health Services',
    mentalWellbeing: 'Mental Wellbeing',
    communitySupport: 'Community Support',

    // Common
    loading: 'Loading...',
    send: 'Send',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    edit: 'Edit',
    copy: 'Copy',
  },

  es: {
    chats: 'Chats',
    newChat: 'Nuevo Chat',
    documents: 'Documentos',
    analytics: 'Analítica',
    profile: 'Perfil',
    settings: 'Configuración',
    language: 'Idioma',
    upgradePlan: 'Plan de Actualización',
    learnMore: 'Aprende Más',
    logout: 'Cerrar Sesión',
    selectLanguage: 'SELECCIONAR IDIOMA',
    admin: 'Administrador',

    messagePlaceholder: 'Pregunta a Tuliza...',
    howCanIHelp: '¿Cómo puedo ayudarte con tu salud y bienestar hoy?',
    askAnything: 'Pregúntame cualquier cosa sobre salud, bienestar o apoyo comunitario',

    quickTopics: 'Temas Rápidos:',
    nhsRegistration: 'Registro NHS',
    healthServices: 'Servicios de Salud',
    mentalWellbeing: 'Bienestar Mental',
    communitySupport: 'Apoyo Comunitario',

    loading: 'Cargando...',
    send: 'Enviar',
    delete: 'Eliminar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    save: 'Guardar',
    edit: 'Editar',
    copy: 'Copiar',
  },

  fr: {
    chats: 'Discussions',
    newChat: 'Nouvelle Discussion',
    documents: 'Documents',
    analytics: 'Analytique',
    profile: 'Profil',
    settings: 'Paramètres',
    language: 'Langue',
    upgradePlan: 'Plan de Mise à Niveau',
    learnMore: 'En Savoir Plus',
    logout: 'Déconnexion',
    selectLanguage: 'SÉLECTIONNER LA LANGUE',
    admin: 'Administrateur',

    messagePlaceholder: "Demandez à Tuliza...",
    howCanIHelp: "Comment puis-je vous aider avec votre santé et bien-être aujourd'hui?",
    askAnything: "Posez-moi n'importe quelle question sur la santé, le bien-être ou le soutien communautaire",

    quickTopics: 'Sujets Rapides:',
    nhsRegistration: 'Inscription NHS',
    healthServices: 'Services de Santé',
    mentalWellbeing: 'Bien-être Mental',
    communitySupport: 'Soutien Communautaire',

    loading: 'Chargement...',
    send: 'Envoyer',
    delete: 'Supprimer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    save: 'Enregistrer',
    edit: 'Modifier',
    copy: 'Copier',
  },

  de: {
    chats: 'Chats',
    newChat: 'Neuer Chat',
    documents: 'Dokumente',
    analytics: 'Analytik',
    profile: 'Profil',
    settings: 'Einstellungen',
    language: 'Sprache',
    upgradePlan: 'Plan Upgraden',
    learnMore: 'Mehr Erfahren',
    logout: 'Abmelden',
    selectLanguage: 'SPRACHE AUSWÄHLEN',
    admin: 'Administrator',

    messagePlaceholder: 'Frag Tuliza...',
    howCanIHelp: 'Wie kann ich Ihnen heute bei Ihrer Gesundheit und Wohlbefinden helfen?',
    askAnything: 'Fragen Sie mich alles über Gesundheit, Wohlbefinden oder Gemeinschaftsunterstützung',

    quickTopics: 'Schnelle Themen:',
    nhsRegistration: 'NHS-Registrierung',
    healthServices: 'Gesundheitsdienste',
    mentalWellbeing: 'Mentales Wohlbefinden',
    communitySupport: 'Gemeinschaftsunterstützung',

    loading: 'Wird geladen...',
    send: 'Senden',
    delete: 'Löschen',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    save: 'Speichern',
    edit: 'Bearbeiten',
    copy: 'Kopieren',
  },

  sw: {
    chats: 'Mazungumzo',
    newChat: 'Mazungumzo Mapya',
    documents: 'Hati',
    analytics: 'Takwimu',
    profile: 'Wasifu',
    settings: 'Mipangilio',
    language: 'Lugha',
    upgradePlan: 'Boresha Mpango',
    learnMore: 'Jifunze Zaidi',
    logout: 'Toka',
    selectLanguage: 'CHAGUA LUGHA',
    admin: 'Msimamizi',

    messagePlaceholder: 'Uliza Tuliza...',
    howCanIHelp: 'Ninaweza kukusaidiaje na afya na ustawi wako leo?',
    askAnything: 'Niulize chochote kuhusu afya, ustawi, au msaada wa jamii',

    quickTopics: 'Mada za Haraka:',
    nhsRegistration: 'Usajili wa NHS',
    healthServices: 'Huduma za Afya',
    mentalWellbeing: 'Ustawi wa Kiakili',
    communitySupport: 'Msaada wa Jamii',

    loading: 'Inapakia...',
    send: 'Tuma',
    delete: 'Futa',
    cancel: 'Ghairi',
    confirm: 'Thibitisha',
    save: 'Hifadhi',
    edit: 'Hariri',
    copy: 'Nakili',
  },

  so: {
    chats: 'Sheekooyin',
    newChat: 'Sheeko Cusub',
    documents: 'Dukumiintiyada',
    analytics: 'Faahfaahin',
    profile: 'Astaamaha',
    settings: 'Dejinta',
    language: 'Luqadda',
    upgradePlan: 'Qorshaha Cusboonaysii',
    learnMore: 'Baro Wax Dheeraad ah',
    logout: 'Ka Bax',
    selectLanguage: 'DOORO LUQADDA',
    admin: 'Maamulaha',

    messagePlaceholder: 'Weydii Tuliza...',
    howCanIHelp: 'Sidee kugu caawin karaa caafimaadkaaga iyo fayoobidda maanta?',
    askAnything: 'Wax kasta i waydii oo ku saabsan caafimaadka, fayoobidda, ama taageerada bulshada',

    quickTopics: 'Mawduucyo Degdeg ah:',
    nhsRegistration: 'Diwaangelinta NHS',
    healthServices: 'Adeegyada Caafimaadka',
    mentalWellbeing: 'Fayoobida Maskaxda',
    communitySupport: 'Taageerada Bulshada',

    loading: 'Soo dejinaya...',
    send: 'Dir',
    delete: 'Tir',
    cancel: 'Jooji',
    confirm: 'Xaqiiji',
    save: 'Keydi',
    edit: 'Wax ka beddel',
    copy: 'Koobiyee',
  },
};

// Get translation function
export const getTranslation = (key, languageCode = 'en') => {
  const lang = translations[languageCode] || translations.en;
  return lang[key] || translations.en[key] || key;
};

// Hook for use in React components
export const useTranslation = () => {
  const languageCode = localStorage.getItem('selectedLanguageCode') || 'en';

  const t = (key) => getTranslation(key, languageCode);

  return { t, languageCode };
};
